import { AuthEffects } from './auth.effects';
import { LanguagesEffects } from './languages.effects';
import { PlanEffects } from './plan.effects';
import { SettingEffects } from './setting.effects';

export { AuthEffects, LanguagesEffects, SettingEffects, PlanEffects };

export const list = [AuthEffects, LanguagesEffects, SettingEffects, PlanEffects];
